import Authenticator from "../protocol/Authenticator";

let _id = 1;

export default class Shape {
  constructor(x=0, y=0, width=100, height=100, id=_id++) {
    this.id = id;
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.creator = Authenticator.AUTH_DATA.username;
  }

  toSvgRect(scale) {
    return {
      id: this.id,
      x: this.x * scale,
      y: this.y * scale,
      width: this.width * scale,
      height: this.height * scale,
      creator: this.creator,
      strokeWidth: 2,
      stroke: '#000',
      fill: 'none'
    };
  }
}
